module.exports = __webpack_public_path__ + "static/media/heart30.8e06c8de.svg";